import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  headers: { 'Content-Type': 'application/json' },
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('assoperf_token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(
  (r) => r,
  (err) => {
    const url = err.config?.url || '';
    // Ces endpoints renvoient 401 pour une MAUVAISE re-saisie du mot de passe,
    // pas pour une session expirée → ne pas déconnecter l'utilisateur.
    const skipLogout =
      url.includes('/auth/login') ||
      url.includes('/account/change-password') ||
      url.includes('/account/delete');
    if (err?.response?.status === 401 && !skipLogout) {
      localStorage.removeItem('assoperf_token');
      localStorage.removeItem('assoperf_user');
      if (!window.location.pathname.startsWith('/login') && !window.location.pathname.startsWith('/register') && window.location.pathname !== '/') {
        window.location.href = '/login';
      }
    }
    return Promise.reject(err);
  }
);
